//import common from '@/store/common/mutations';
import * as types from './mutation-types';

export default {
	//	...common,
	[types.STATE_INIT]: state => {
		state.usePlCdList = []; //조회조건에 사용장소
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.MESEQIPNO_LIST]: (state, payload) => {
		state.mesEqipNoList = payload;
		if (state.mesEqipNoList != null) {
			state.mesEqipNoList.forEach(row => {
				//if (row.commCdType == null) row.commCdType = '[공통코드 선택]';

				Object.keys(row).forEach(item => {
					// if (item == 'regDt') {
					// 	let tmpDate = new Date(row[item]);
					// 	row[item] =
					// 		tmpDate.getFullYear() +
					// 		'-' +
					// 		('0' + (tmpDate.getMonth() + 1)).substr(0, 2) +
					// 		'-' +
					// 		('0' + tmpDate.getDate()).substr(0, 2) +
					// 		' ' +
					// 		('0' + tmpDate.getHours()).substr(0, 2) +
					// 		':' +
					// 		('0' + tmpDate.getMinutes()).substr(0, 2) +
					// 		':' +
					// 		('0' + tmpDate.getSeconds()).substr(0, 2);
					// }
				});
			});
		}
	}
};
